import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { useLingui } from '@lingui/react';
import { Button } from '@mantine/core';
import classes from './Button.module.css';
export const SignUpButton = () => {
  const {
    setOpenModal
  } = useModalAction();
  const {
    i18n
  } = useLingui();
  return <Button visibleFrom="md" c="dark" onClick={() => setOpenModal(MODAL.REGISTER)} leftSection={<Icons className="icon-pr-line-log-in" color="var(--mantine-color-dark-4)" fontSize={24} />} tt="uppercase" classNames={classes}>
      {i18n._('Sign up now')}
    </Button>;
};